import Vue from "vue";
import { cloneDeep } from "lodash";
import api from "@/api/portal-beneficiario";

const createParcelamentoFatura = ({ payload, nextStep = false }, store) => {
  return Vue.api
    .post(api.createParcelamento, JSON.parse(payload))
    .then(({ data }) => {
      if (nextStep) {
        const codigoParcelamento =
          store.getters["portal/getCodigoParcelamento"];

        listFaturaAbertaPorBeneficiario(
          { payload: `{"codigoParcelamento": "${codigoParcelamento}"}` },
          store
        );
      } else {
        store.commit("portal/GENERIC_MUTATION", {
          property: "faturaSelected",
          payload: data?.content[0]
        });
        store.commit("portal/GENERIC_MUTATION", {
          property: "initialStateFaturaSelected",
          payload: cloneDeep(data?.content[0])
        });
        store.commit("portal/GENERIC_MUTATION", {
          property: "numberOfElementsFaturas",
          payload: data?.numberOfElements
        });
      }
    })
    .catch(({ response }) => {
      store.commit("portal/setToast", response.data.message);
    });
};

const listFaturaAbertaPorBeneficiario = ({ payload }, store) => {
  return Vue.api
    .post(api.listFaturaEmAberto, JSON.parse(payload))
    .then(({ data }) => {
      store.commit("portal/GENERIC_MUTATION", {
        property: "selecionarBeneficiario",
        payload: data?.content
      });

      store.commit("portal/GENERIC_MUTATION", {
        property: "numberOfElementsListFaturaPorBeneficiario",
        payload: data?.numberOfElements
      });

      store.commit("portal/nextStep");
    });
};

const atualizarQtdParcelamento = ({ payload }, store) => {
  return Vue.api
    .post(api.atualizarQtdParcelamento, JSON.parse(payload))
    .then(() => {
      const codigoParcelamento = store.getters["portal/getCodigoParcelamento"];
      visualizarParcelamento(codigoParcelamento, store);
    })
    .catch(({ response }) => {
      store.commit("portal/setToast", response.data.message);
    });
};

const visualizarParcelamento = (codigoParcelamento, store) => {
  return Vue.api
    .post(
      api.visualizarParcelamento,
      JSON.parse(`{"codigoParcelamento": "${codigoParcelamento}"}`)
    )
    .then(({ data }) => {
      store.commit("portal/GENERIC_MUTATION", {
        property: "visualizaParcelamento",
        payload: data?.content[0]
      });

      store.commit("portal/GENERIC_MUTATION", {
        property: "numberOfElementsVisualizaParcelamento",
        payload: data?.numberOfElements
      });

      store.commit("portal/nextStep");
    })
    .catch(({ response }) => {
      store.commit("portal/setToast", response.data.message);
    });
};

const concluiParcelamento = ({ payload }, store, router) => {
  return Vue.api
    .post(api.concluiParcelamento, JSON.parse(payload))
    .then(() => {
      router.push({
        name: "faturas"
      });

      store.commit("portal/resetStep");
    })
    .catch(({ response }) => {
      store.commit("portal/setToast", response.data.message);
    });
};

const relatorioParcelamento = ({ payload }, store) => {
  return Vue.api
    .post(api.relatorioParcelamento, JSON.parse(payload))
    .then(({ data }) => {
      const url = data?.content.map(fatura => fatura?.url);
      window.open(url);
    })
    .catch(({ response }) => {
      store.commit("portal/setToast", response.data.message);
    });
};

export {
  createParcelamentoFatura,
  listFaturaAbertaPorBeneficiario,
  atualizarQtdParcelamento,
  visualizarParcelamento,
  concluiParcelamento,
  relatorioParcelamento
};
